export default "__VITE_ASSET__EPrRHGia__"